<template>
  <div class="page-container appdetail_wrap">
    <!-- 头部的Header -->
    <store-header
      :marketInfo="marketInfo"
      :marketClosed="marketClosed"
      :hasError="true"
      :isActive="false"
      :home="true"
      :isDetailPage="true"
    ></store-header>
    <!-- 面包屑 -->
    <div class="appdetail_breadcrumb">
      <div class="breadcrumb_first">
        <router-link
          :to="{
            name: 'appstore'
          }"
          class="breadcrumb_link"
        >
          首页
        </router-link>
        <router-link
          v-if="parentNode"
          :to="{
            name: 'appstore',
            params: { parentId: parentId, type: 'parent' }
          }"
          class="breadcrumb_link"
        >
          {{ parentNode }}
        </router-link>
        <router-link
          :to="{
            name: 'appstore',
            params: {
              childId: childId,
              parentId: parentId,
              type: 'child'
            }
          }"
          class="breadcrumb_link"
        >
          <span class="breadTitle">{{ childNode || appDetailInfo.name }}</span>
        </router-link>
      </div>
    </div>
    <!-- 主体布局 -->
    <!-- <h2>应用详情</h2> -->
    <div
      class="appdetail_main"
      :style="{
        'min-height': detailLoading ? '80vh' : ''
      }"
    >
      <!-- 左侧所有部分 -->
      <div v-loading="detailLoading" class="app_desc_box">
        <div class="app_base_info">
          <!-- 标题 logo行 -->
          <div class="title_icon_row">
            <div class="logobox">
              <img :src="appDetailInfo.logo || appLogoDef" />
            </div>
            <div class="title_info">
              <div class="title_content">
                <h1 class="title_name">
                  {{ appDetailInfo.name }}
                </h1>
                <div class="title_tag">
                  <!-- Helm 标签 -->
                  <div
                    class="tag_box"
                    v-for="item in models"
                    :key="item.templateType"
                  >
                    <div class="tag_icon">
                      <img
                        :src="
                          item.templateType == 'helm'
                            ? helmIcon
                            : item.templateType == 'RAM'
                            ? ramIcon
                            : item.templateType == 'docker'
                            ? dockerIcon
                            : fileIcon
                        "
                        :alt="
                          item.templateType == 'helm'
                            ? 'helm'
                            : item.templateType == 'RAM'
                            ? 'ram'
                            : item.templateType == 'docker'
                            ? 'docker'
                            : 'file'
                        "
                      />
                      <!-- <img class="helm_icon" src="../../assets/images/helm.svg" alt="" /> -->
                    </div>
                    <div class="tag_name">{{ item.label }}</div>
                  </div>
                  <!-- 普通标签 -->
                  <div class="tag_box" v-if="parentNode">
                    <div class="tag_icon">
                      <img
                        class="helm_icon"
                        src="../../assets/images/tag-type.svg"
                        alt=""
                      />
                    </div>
                    <div class="tag_name">
                      {{ parentNode }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="app_count_data">
                <div class="author" v-if="appDetailInfo.realname">
                  <div class="app_img">
                    <img src="../../assets/images/author.svg" alt="" />
                  </div>
                  <small>作者:</small>
                  <div
                    class="app_value"
                    @click="handleJumoAllApp(appDetailInfo)"
                  >
                    {{ appDetailInfo.realname }}
                  </div>
                </div>
                <div class="app_version">
                  <div class="app_img">
                    <img src="../../assets/images/version.svg" alt="" />
                  </div>
                  <small>最新版本:</small>
                  <div class="app_value">
                    {{ appDetailInfo.maxVersion }}
                  </div>
                </div>
                <div class="install" v-if="appDetailInfo.installCount != 0">
                  <div class="app_img">
                    <img src="../../assets/images/install.svg" alt="" />
                  </div>
                  <small>安装次数:</small>
                  <div class="app_value">
                    {{ appDetailInfo.installCount }}次
                  </div>
                </div>
                <div class="time_update" v-if="appDetailInfo.updateTime">
                  <div class="app_img">
                    <img src="../../assets/images/time-update.svg" alt="" />
                  </div>
                  <small>更新时间:</small>
                  <div class="app_value">
                    {{ timmer(appDetailInfo.updateTime) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="app_desc">
            <p>{{ appDetailInfo.desc }}</p>
          </div>
          <div class="app_detail_info">
            <!-- 应用名称和简介 -->
            <div class="verion_info">
              <div
                class="version_items show_price"
                v-if="
                  curPackageInfo &&
                  curPackageInfo.packageType != 'free'
                "
              >
                <div
                  class="label"
                  v-if="
                    curPackageInfo.packageType !== 'business' &&
                    curPackageInfo.packageType === 'pay'
                  "
                >
                  <i>¥</i>
                </div>
                <div
                  class="label"
                  v-if="
                    curPackageInfo && curPackageInfo.packageType !== 'business'
                  "
                >
                  <span style="font-size: 32px">{{
                    curPackageInfo.packageType === 'pay'
                      ? curPackageInfo.price + '元/'
                      : '免费'
                  }}</span>
                  {{
                    curPackageInfo && curPackageInfo.packageType === 'pay'
                      ? showDateZh[curPackageInfo.billCycle]
                      : ''
                  }}
                </div>
                <div v-else style="color: #1890ff; font-size: 16px">
                  <strong>温馨提示:</strong>
                  该应用需联系商家授权使用
                </div>
              </div>
              <template v-if="models.length > 1">
                <div class="version_item">
                  <div class="label" style="line-height: 40px">包类型：</div>
                  <div
                    class="package_box"
                    style="display: flex; align-items: center"
                  >
                   <el-select style="width: 160px" v-model="radio" placeholder="请选择" @change="handlePackageTypeChange">
                    <el-option
                      label="所有类型"
                      value="all"
                    >
                    </el-option>
                    <template slot="prefix" v-if="radio != 'all'">
                      <span style="padding-left: 2px;">
                        <img
                          :src="
                          radio == 'helm'
                            ? helmIcon
                            : radio == 'RAM'
                            ? ramIcon
                            : radio == 'docker'
                            ? dockerIcon
                            : radio == 'flie'
                            ? fileIcon
                            : ''
                          "
                          alt=""
                          style="width: 20px; height: 20px; margin-top: 6px"
                        />
                      </span>
                    </template>
                    <el-option
                      v-for="item in models"
                      :key="item.templateType"
                      :label="item.label"
                      :value="item.templateType"
                    >
                    <span style="float: left">
                      <img
                        :src="
                          item.templateType == 'helm'
                            ? helmIcon
                            : item.templateType == 'RAM'
                            ? ramIcon
                            : item.templateType == 'docker'
                            ? dockerIcon
                            : fileIcon
                        "
                        :alt="
                          item.templateType == 'helm'
                            ? 'helm'
                            : item.templateType == 'RAM'
                            ? 'ram'
                            : item.templateType == 'docker'
                            ? 'docker'
                            : 'file'
                        "
                        style="width: 20px; height: 20px; margin-right: 5px"
                      />
                    </span>
                    <span style="color: #8492a6; font-size: 13px">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                  </div>
                </div>
              </template>
              <template>
                <div class="version_item">
                  <div class="label">版本：</div>
                  <div class="package_box">
                    <div
                      class="block_box_version"
                      v-for="item in versionList"
                      :key="item.appVersion + item.templateType"
                      :class="
                        curAppVersion.appVersion == item.appVersion &&
                        curAppVersion.templateType == item.templateType &&
                        'selected_version'
                      "
                      @click="curAppVersion = item"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.arch"
                        placement="top"
                      >
                      <div slot="content" class="tips-content text-tips-content">
                        <div class="rule-box">
                          <p>类型：{{ item.templateType }}</p>
                          <p>版本：{{ item.appVersion }}</p>
                          <p v-if="item.arch != ''">架构：{{ item.arch }}</p>
                        </div>
                      </div>
                        <div
                          class="appVersionBox"
                          @click="handleCurVersion(item)"
                        >
                          <div class="appTypeIcon">
                            <!-- {{ item.templateType }} -->
                            <img
                            :src="
                              item.templateType == 'helm'
                                ? helmIcon
                                : item.templateType == 'RAM'
                                ? ramIcon
                                : item.templateType == 'docker'
                                ? dockerIcon
                                : fileIcon
                            "
                            :alt="
                              item.templateType == 'helm'
                                ? 'helm'
                                : item.templateType == 'RAM'
                                ? 'ram'
                                : item.templateType == 'docker'
                                ? 'docker'
                                : 'file'
                            "
                          />
                          </div>
                          <div class="appTypeVersion">
                            {{ item.appVersion }}
                          </div>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="curVersionPackageList.length > 0">
                <div class="version_item">
                  <div class="label">套餐：</div>
                  <div class="package_box">
                    <div
                      class="block_box_version"
                      v-for="item in curVersionPackageList"
                      :class="
                        curPackageInfo.packageID == item.packageID &&
                        'selected'
                      "
                       @click="curPackageInfo = item"
                      :key="item.packageID"
                      :title="item.name"
                    >
                      <div class="appVersionPackage">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div style="display: flex; flex-wrap: wrap; padding-left: 72px">
              <!-- 申请试用 -->
              <div class="btns_box">
                <div
                  class="jump_btn"
                  v-if="curPackageInfo && curPackageInfo.isTrial"
                  @click="gotoBuy('trial')"
                >
                  申请试用
                </div>
              </div>
              <div
                class="btns_box"
                style="margin-left: '5px'"
                v-if="templateType == 'file'"
              >
                <div class="jump_btn" @click="handleDownloadFile">下载</div>
              </div>
              <!-- 立即购买 -->
              <div
                class="btns_box"
                v-if="curPackageInfo && curPackageInfo.packageType === 'pay'"
              >
                <div class="jump_btn" @click="gotoBuy('new')">立即购买</div>
              </div>
              <!-- 立即下载 -->
              <div
                class="btns_box"
                style="margin-left: '5px'"
                v-if="downloadUrl"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="下载离线应用包可导入到 Rainbond平台"
                  placement="top"
                >
                  <template slot="content">
                    <p>下载离线应用包可导入到 Rainbond平台。</p>
                  </template>
                  <div class="jump_btn" @click="gotoBuy('download')">下载</div>
                </el-tooltip>
                <p style="font-size: 12px; color: #8e8b8b; margin-top: 4px">
                  <a
                    href="https://hub.grapps.cn/docs/install/RAM/appPackage#rainbond-%E5%AF%BC%E5%85%A5-ram-%E5%AE%89%E8%A3%85%E5%8C%85%E9%83%A8%E7%BD%B2"
                    target="_blank"
                    >如何使用<i class="el-icon-question"></i
                  ></a>
                </p>
              </div>
              <!-- 跳转按钮 -->
              <!-- <div class="jump_btn" @click="handleJumpDocs" v-if="curPackageInfo.packageType === 'free'">
                在线安装
              </div> -->
              <div
                class="jump_btn"
                @click="handleOpenInstallRam"
                v-if="
                  templateType == 'RAM' &&
                  (!curPackageInfo ||
                    (curPackageInfo && curPackageInfo.packageType === 'free'))
                "
              >
                安装
              </div>
              <div
                class="jump_btn"
                @click="handleOpenInstallHelm"
                v-if="templateType == 'helm'"
              >
                安装
              </div>
              <div
                class="jump_btn"
                @click="handleOpenInstallDocker"
                v-if="templateType == 'docker'"
              >
                安装
              </div>
              <div
                v-if="
                  curPackageInfo && curPackageInfo.packageType === 'business'
                "
                class="jump_btn"
                @click="enterVisible = true"
              >
                商业咨询
              </div>
            </div>
          </div>
        </div>
        <div class="hostAppContent">
          <h3 v-if="hotAppList && hotAppList.length > 0">相关应用</h3>
          <div
            class="hostAppItem"
            @click="viewHotApp(item)"
            v-for="item in hotAppList"
            :key="item.appKeyID"
          >
            <div class="hostTime">
              {{ timmer(item.updateTime) }}
            </div>
            <div class="itemIcon">
              <img :src="item.logo || appLogoDef" />
            </div>
            <div class="itemDetail">
              <a class="itemTitle">
                <span>
                  {{ item.name }}
                </span>
              </a>
              <div class="desc">
                <p style="height: 36px">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="app_detail_info"
        style="width: 100%"
        id="packageDetail"
        v-if="isIndexLoading"
      >
        <!-- 锚点链接 -->
        <div
          class="titleAnchorPointAll"
          ref="stickyBox"
          :class="{ hideValueAnchor: hideValueAnchor }"
        >
          <div class="titleAnchorPoint">
            <span
              class="introduce"
              v-if="appDetailInfo.introduction != '' && appDetailInfo.introduction != '<p><br></p>'"
              :class="{ active: activeKey === 'introduce' }"
              @click="goAnchor('introduce')"
              >应用介绍</span
            >
             <span
              class="version"
              v-if="isMarkdown"
              :class="{ active: activeKey === 'version' }"
              @click="goAnchor('version')"
              >版本详情</span
            >
            <span
              class="history"
              v-if="historyVersionList.length > 0"
              :class="{ active: activeKey === 'history' }"
              @click="goAnchor('history')"
              >历史版本信息</span
            >
            <span
              class="author"
              v-if="appDetailInfo.realname"
              :class="{ active: activeKey === 'author' }"
              @click="goAnchor('author')"
              >作者介绍</span
            >
            <span
              class="commit"
              :class="{ active: activeKey === 'commit' }"
              @click="goAnchor('commit')"
              >用户评论
              <a style v-if="commentList.length > 0">({{ commentList.length}})</a>
            </span>
          </div>
        </div>
        <!-- 锚点内容 -->
        <div class="detailContent">
          <div class="valueAnchorPoint">
            <!-- 应用介绍 -->
            <el-divider
              content-position="center"
              v-if="appDetailInfo.introduction != '' && appDetailInfo.introduction != '<p><br></p>'"
            >
              <svg-icon
                icon-class="introduce-details"
                shape="square"
                :size="80"
              ></svg-icon>
            </el-divider>
            <div
              id="introduce"
              v-if="appDetailInfo.introduction != '' && appDetailInfo.introduction != '<p><br></p>'"
              class="styleBox"
            >
              <div
                class="app_detail_introduce"
                v-html="appDetailInfo.introduction"
              ></div>
            </div>
            <!-- 版本详情 -->
            <el-divider
              content-position="center"
              v-if="isMarkdown"
            >
              <svg-icon
                icon-class="use-details"
                shape="square"
                :size="80"
              ></svg-icon>
            </el-divider>
            <div
              id="version"
              v-if="isMarkdown"
              class="styleBox"
            >
              <div
                v-if="!isMarkdown"
                class="app_detail_introduce"
                v-html="appDetailInfo.introduction"
              ></div>
              <MarkdownPreview
                v-if="isMarkdown"
                :initialValue="isMarkdownValue"
                v-loading="isMarkdownLodaing"
              />
            </div>
            <!-- 历史版本信息 -->
            <el-divider
              content-position="center"
              v-if="historyVersionList.length > 0"
            >
              <svg-icon
                icon-class="history-details"
                shape="square"
                :size="80"
              ></svg-icon>
            </el-divider>
            <div
              id="history"
              v-if="historyVersionList.length > 0"
              class="styleBox"
            >
              <div class="block">
                <div
                  class="history_versions"
                  v-for="item in historyVersionList"
                  :key="item.appVersion"
                >
                  <div class="versions_box">
                    <div class="versions_name">
                      {{ item.appVersion }}
                    </div>
                    <div class="versions_time">
                      {{ timmer(item.createTime) }}
                    </div>
                  </div>
                  <div class="versions_content">
                    {{ item.desc }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 作者介绍 -->
            <el-divider content-position="center" v-if="appDetailInfo.realname">
              <svg-icon
                icon-class="author-details"
                shape="square"
                :size="80"
              ></svg-icon>
            </el-divider>
            <div id="author" v-if="appDetailInfo.realname" class="styleBox">
              <div
                class="marketInfo"
                v-if="appDetailInfo.realname"
                id="userLogo"
              >
                <div class="user_logo" slot="reference">
                  <el-avatar
                    :size="100"
                    v-if="appDetailInfo.picURL"
                    :src="appDetailInfo.picURL"
                  >
                  </el-avatar>
                  <el-avatar :size="100" v-else>
                    {{ appDetailInfo.realname }}
                  </el-avatar>
                </div>
                <div>
                  <div
                    class="marketItemName"
                    v-if="appDetailInfo.realname"
                    style="cursor: pointer"
                    @click="handleJumoAllApp(appDetailInfo)"
                  >
                    {{ appDetailInfo.realname }}
                  </div>
                  <div class="marketItems" v-if="appDetailInfo.userDes">
                    <p>{{ appDetailInfo.userDes }}</p>
                  </div>
                  <div class="marketItem" v-if="appDetailInfo.email">
                    <img src="../../assets/images/emails.png" alt="" />：
                    <p>{{ appDetailInfo.email }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 用户评论 -->
            <el-divider content-position="center">
              <img src="@/assets/images/commit.svg" alt="" />
            </el-divider>
            <div id="commit">
              <Commit :appID="appId" :appName="appDetailInfo.name" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer :isTheme="isTheme"></app-footer>
    <Enter
      v-if="enterVisible"
      v-model="enterVisible"
      :appDetailInfo="appDetailInfo"
    ></Enter>
    <InstallHelmChart
      v-if="showOpenInstallHelm"
      :appDetailInfo="appDetailInfo"
      :helmChartVersion="appVersion"
      :marketID="marketId"
      :dialogVisible="showOpenInstallHelm"
      :helmVersionAlias="helmVersionAlias"
      :onClose="() => (showOpenInstallHelm = false)"
    >
    </InstallHelmChart>
    <InstallDocker
      v-if="showOpenInstallDocker"
      :appDetailInfo="appDetailInfo"
      :dockerCmd="dockerCmd"
      :marketID="marketId"
      :dialogVisible="showOpenInstallDocker"
      :onClose="() => (showOpenInstallDocker = false)"
    >
    </InstallDocker>
    <InstallRam
      v-if="showOpenInstallRam"
      :appDetailInfo="appDetailInfo"
      :ramVersion="appVersion"
      :dialogVisible="showOpenInstallRam"
      :onClose="() => (showOpenInstallRam = false)"
    >
    </InstallRam>
    <div class="backtop">
      <el-popover placement="left" trigger="hover">
        <img class="wechart" :src="marketInfo && marketInfo.banners && marketInfo.banners.length > 0 && marketInfo.banners[0].imageURL" alt="" />
        <p
          style="
            font-size: 12px;
            margin-bottom: 0px;
            margin-top: 6px;
            text-align: center;
          "
        >
          扫一扫，邀你进群交流吧
        </p>
        <div slot="reference">
          <img src="../../assets/images/feedback.svg" alt="" />
        </div>
      </el-popover>
    </div>
    <el-backtop style="right: 14px"></el-backtop>
  </div>
</template>
<script>
import { postAccessInfo } from '@/api/accessInfo';
import { appShow, getDownloadToken, fetchAppComments } from '@/api/app';
import {
  getAppDetailApi,
  getCategoryListApi,
  getDownloadListApi,
  getMarketBaseInfoApi,
  getRelatedApp,
  getHistoryVersionInfo,
  getAppVersionPackage,
  downloadFilePackage
} from '@/api/appStore';
import logoImg from '@/assets/images/logo.svg';
import { setWebInfo } from '@/utils/common';
import { errorHandle } from '@/utils/error';
import { fetchdayTimes } from '@/utils/timmer';
import Enter from './components/Enter.vue';
import ShufflingSearch from './components/shufflingSearch';
import Commit from './components/commit';
import InstallHelmChart from './components/InstallHelmChart';
import InstallRam from './components/InstallRam';
import InstallDocker from './components/InstallDocker';
import { MarkdownPreview } from 'vue-meditor';
import helmIcon from '@/assets/images/helm.svg';
import fileIcon from '@/assets/images/file.svg';
import ramIcon from '@/assets/images/ram.svg';
import dockerIcon from '@/assets/images/docker.svg';
import moment from 'moment';

export default {
  name: 'AppDetail',
  data() {
    return {
      commentList: [],
      helmIcon,
      fileIcon,
      ramIcon,
      dockerIcon,
      isTheme: true,
      appLogoDef: require('../../assets/images/app_icon.png'),
      marketId: '',
      marketInfo: {},
      appId: '',
      appDetailInfo: {},
      hotAppList: [],
      versionList: [],
      appVersion_index: 0,
      isShowVerionList: false,
      allPackageInfo: {},
      curVersionPackageList: [],
      curPackageInfo: false,
      curAppVersion: {},
      showDateZh: { month: '月', year: '年', quarter: '季度', week: '周' },
      searchQuery: '',
      detailLoading: true,
      hotLoading: true,
      downloadUrl: '',
      btnLoading: false,
      installCount: 0,
      routevalue: 'clouddemo',
      currentheight: null, // 按钮隐藏
      switch_cutting: false,
      logoImg,
      marketClosed: false,
      marketInfo: {},
      tempArr: [],
      tabflag: false,
      enterVisible: false,
      arr: [],
      activeName: 'first',
      versionItem: '',
      selectorActive: '#packageDetail',
      showButton: true,
      radio: '',
      isSticky: false,
      activeKey: 'introduce',
      hideValueAnchor: false,
      showOpenInstallHelm: false,
      showOpenInstallRam: false,
      showOpenInstallDocker: false,
      helmChartVersion: '',
      ramVersion: '',
      isMarkdown: false,
      isMarkdownValue: '',
      isMarkdownLodaing: false,
      isIndexLoading: false,
      historyVersionList: [],
      childNode: '',
      parentNode: '',
      childId: '',
      parentId: '',
      dockerCmd: '',
      appPackageType: [
        { label: 'Helm Chart', value: 'helm' },
        { label: 'Docker', value: 'docker' },
        { label: 'Rainbond App Model', value: 'rainbond' },
        { label: '软件包', value: 'file' }
      ],
      models: [],
      templateType: '',
      appVersion: '',
      radio: 'all',
      commentList: []
    };
  },
  watch: {
    '$route.path': function(newVal, oldVal) {
      if (/^\/marketplace\/apps\/((?:[^\/]+?))(?:\/(?=$))?$/i.test(newVal)) {
        this.initData();
      }
    }
  },
  created() {
    this.initData();
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    sections() {
      // 获取所有部分的DOM元素
      return Array.from(document.querySelectorAll('.valueAnchorPoint > div'));
    },
    historySection() {
      // 获取历史部分的 DOM 元素
      return document.getElementById('commit');
    }
  },
  components: {
    ShufflingSearch,
    Enter,
    InstallHelmChart,
    MarkdownPreview,
    InstallRam,
    Commit,
    InstallDocker
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('scroll', this.onScrolls);
    });
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this.scrollActiveSection);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolls);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.scrollActiveSection);
  },
  methods: {
    initData() {
      const params = this.$route.params;
      // this.marketId = params.marketID;
      this.marketId = '859a51f9bb3b48b5bfd222e3bef56425';
      this.appId = params.appID;
      if (this.marketId && this.appId) {
        this.getStoreInfo();
      }
    },
    scrollActiveSection() {
      // 检查每个部分的位置
      for (let i = 0; i < this.sections.length; i++) {
        const section = this.sections[i];
        const rect = section.getBoundingClientRect();
        if (rect.top <= 80) {
          // 当前部分在或超过顶部时，设置为活动部分
          if (section.id) {
            this.activeKey = section.id;
          }
        }
      }
    },
    handleScroll() {
      const stickyBox = this.$refs.stickyBox;
      const rect = stickyBox.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      if (rect.top <= 0) {
        stickyBox.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.2)';
      } else {
        stickyBox.style.boxShadow = '0 0 0';
      }
      const historyRect = this.historySection.getBoundingClientRect();
      const historyBottom = historyRect.bottom;

      if (historyBottom <= 80) {
        this.hideValueAnchor = true;
      } else {
        this.hideValueAnchor = false;
      }
    },
    scrollActiveSection() {
      const windowHeight = window.innerHeight; // 视口的高度
      const middlePosition = (windowHeight * 3) / 5; // 视口的中间位置

      for (let i = 0; i < this.sections.length; i++) {
        const section = this.sections[i];
        const rect = section.getBoundingClientRect();
        if (rect.top <= middlePosition && rect.bottom >= middlePosition) {
          // 当部分的顶部小于等于中间位置且底部大于等于中间位置时，设置为活动部分
          if (section.id) {
            this.activeKey = section.id;
          }
        }
      }
    },
    goAnchor(id) {
      const targetElement = document.getElementById(id);
      if (targetElement) {
        const windowHeight = window.innerHeight; // 视口的高度
        const middlePosition = (windowHeight * 3) / 5; // 视口的中间位置

        const rect = targetElement.getBoundingClientRect();
        const targetPosition = rect.top + window.pageYOffset - middlePosition;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        setTimeout(() => {
          this.activeKey = id; // 设置为活动部分
        }, 100);
      }
    },
    handleJumoAllApp(data) {
      this.$router.push({ path: '/marketplace/publisher/' + data.publishUser });
    },
    handleJumpDocs() {
      window.open('https://www.rainbond.com/docs/store/install/onLineInstall');
    },
    postAccessInfo() {
      postAccessInfo({
        marketID: this.marketId,
        appID: this.appDetailInfo.appKeyID
      }).catch((err) => {});
    },
    fetchDownloadList() {
      this.downloadUrl = ''
      // this.hotLoading = true;
      getDownloadListApi({
        marketId: this.marketId,
        appID: this.appDetailInfo.appKeyID,
        versions: this.appVersion
      })
        .then((res) => {
          if (res && res.length > 0) {
            this.downloadUrl = res[0].downloadURL;
          }
        })
        .catch(() => {
          this.hotLoading = false;
        });
    },
    rate(row) {
      const rate = (row.installCount + row.showCount) / 50;
      return rate > 5 ? 5 : rate;
    },
    getStoreInfo() {
      getMarketBaseInfoApi({
        marketId: this.marketId
      })
        .then((res) => {
          window.sessionStorage.setItem(
            'storeDomain',
            JSON.stringify(res.domain)
          );
          this.marketInfo = res;
          this.marketId = res.marketID;
          this.getCategoryList();
          this.getAppDetail();
        })
        .catch((re) => {
          // market is not exist, redirect to default market index
          if (re.code == 404 || re.code == 10011) {
            this.$router.push({
              name: 'index',
              params: {
                marketID: this.defaultMarketDomain
              }
            });
          } else if (re.code == 10019) {
            this.marketClosed = true;
          } else {
            // this.$router.push({
            //   name: '500'
            // });
          }
        });
    },
    getCategoryList() {
      getCategoryListApi({
        marketId: this.marketId
      }).then((res) => {
        res.tree &&
          res.tree.forEach((item) => {
            item.extend = true;
          });
        this.categoryList = res.tree;
      });
    },
    // 应用详情
    getAppDetail() {
      this.detailLoading = true;
      getAppDetailApi({
        marketId: this.marketId,
        appId: this.appId
      })
        .then((res) => {
          if (res) {
            this.isIndexLoading = true;
            if (res.publishUser == this.userInfo.userID) {
              this.showButton = false;
            }
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = res.introduction;
            var headings = tempDiv.querySelectorAll('h1, h2, h3, h4, h5, h6');
            // 遍历标题标签并输出内容
            const obj = [];
            for (var i = 0; i < headings.length; i++) {
              var heading = headings[i];
              var tagName = heading.tagName.toLowerCase();
              heading.id = 'heading-' + i;
              // 判断标签的级别
              obj.push({ key: tagName, value: heading.textContent });
            }
            this.tempArr = [];
            this.allPackageInfo = {};
            this.curAppVersion = {};
            this.appDetailInfo = res;
            this.appDetailInfo.introduction = tempDiv.innerHTML;
            if (res.models.length > 0) {
              this.models = res.models;
              this.handlePackageTypeChange();
              this.templateType = res.models[0].versions[0].templateType;
              this.appVersion = res.models[0].versions[0].appVersion;
              this.helmVersionAlias = res.models[0].versions[0].appVersionAlias;
              this.dockerCmd = res.models[0].versions[0].cmd;
              this.handleAppVersionPackageInfo(res.models[0].versions[0]);
              this.curAppVersion = res.models[0].versions[0];
              if (res.models[0].versions[0].detail != '') {
                this.isMarkdown = true;
                this.isMarkdownValue = res.models[0].versions[0].detail;
              }
              this.fetchDownloadList();
            }
            // 判断父级分类还是子级分类
            if (res.appClassifications.length > 0) {
              res.appClassifications.forEach((item) => {
                if (item.parentAppClassificationID == '') {
                  this.parentNode = item.appClassificationName;
                  this.parentId = item.appClassificationID;
                } else {
                  this.childNode = item.appClassificationName;
                  this.childId = item.appClassificationID;
                }
              });
            }
            this.detailLoading = false;
            this.showCountAdd();
            this.getAppComments();
            this.postAccessInfo();
            this.handleHistoryInfo();
            this.getCorrelationAppList();
            setWebInfo('AI智能体市场-' + res.name, res.desc);
          }
        })
        .catch((err) => {
          this.detailLoading = false;
          if (err.code == '10009') {
            this.$router.push({ name: '404' });
          }
        });
    },
    // 选择包类型筛选版本
    handlePackageTypeChange(val = 'all') {
      this.versionList = [];
      if (val == 'all') {
        this.models.map((item) => {
          this.versionList = [...this.versionList, ...item.versions];
        });
      } else {
        this.models.map((item) => {
          if (item.templateType == val) {
            this.versionList = item.versions;
            this.templateType = item.versions[0].templateType;
            this.dockerCmd = item.versions[0].cmd;
            this.helmVersionAlias = item.versions[0].appVersionAlias;
            this.appVersion = item.versions[0].appVersion;
            this.curAppVersion = item.versions[0];
            this.isMarkdownValue = item.versions[0].detail;
            this.handleAppVersionPackageInfo(item.versions[0])
          }
        });
      }
      this.fetchDownloadList()
      this.handleHistoryInfo(val)
    },
    showCountAdd() {
      appShow({ marketID: this.marketId, appID: this.appId }).catch(() => {});
    },
    // 应用历史版本信息
    handleHistoryInfo(type = 'all') {
      var params = {
        marketID: this.marketId,
        appID: this.appId,
        templateType: type
      };
      getHistoryVersionInfo(params)
        .then((res) => {
          this.historyVersionList = res.AppVersionBases || [];
        })
        .catch((err) => {
          console.log(err, 'err');
        });
    },
    // 相关应用
    getCorrelationAppList(keyID) {
      var params = {
        marketID: this.marketId,
        appID: this.appId,
        apptype: this.parentId
      };
      this.hotLoading = true;
      getRelatedApp(params)
        .then((res) => {
          this.hotAppList = res.apps || [];
          this.hotLoading = false;
        })
        .catch(() => {
          this.hotLoading = false;
        });
    },
    // 获取版本套餐
    handleAppVersionPackageInfo(item) {
      getAppVersionPackage({
        marketID: this.marketId,
        appID: this.appId,
        version: item.appVersion,
        templateType: item.templateType
      }).then((res) => {
        this.curVersionPackageList = res.packages || [];
        this.curPackageInfo = this.curVersionPackageList[0];
      });
    },
    // 切换版本
    handleCurVersion(key) {
      this.templateType = key.templateType;
      this.helmVersionAlias = key.appVersionAlias;
      this.dockerCmd = key.cmd;
      this.appVersion = key.appVersion;
      if (key.detail != '') {
        this.isMarkdown = true;
        this.isMarkdownValue = key.detail;
      } else {
        this.isMarkdown = false;
      }
      this.fetchDownloadList()
      this.handleAppVersionPackageInfo(key);
    },
    // 获取评论
    getAppComments() {
      const commentInfo = {
        marketID: '859a51f9bb3b48b5bfd222e3bef56425',
        appID: this.appId
      }
      fetchAppComments(commentInfo).then(res => {
        if (res) {
          this.commentList = res
        }
      })
    },
    // 查看热门应用
    viewHotApp(item) {
      this.selectorActive = '#packageDetail';
      if (this.appId == item.appKeyID) return;
      this.$router.replace({
        path: `/marketplace/apps/${item.appKeyID}`
      });
    },
    // 试用、购买
    gotoBuy(type) {
      if (this.showButton == false) {
        this.$message({
          message: '您不能操作自己创作的应用。',
          type: 'warning',
          center: true
        });
        return null;
      }
      if (type != 'download' && type != 'file') {
        if (!(this.userInfo && this.userInfo.userID)) {
          this.$confirm('你还未登录，去登录？', '提示', {
            confirmButtonText: '前往',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              name: 'login',
              query: { redirect: this.$route.fullPath }
            });
          });
          return null;
        }
      }
      if (type === 'download') {
        // this.fetchDownloadToken();
        this.download(`${this.downloadUrl}`);
        return null;
      }
      if (!this.curPackageInfo.packageID) {
        this.$message.warning('请选择套餐');
        return null;
      }
      this.$router.push({
        name: 'confirmOrder',
        query: {
          marketID: this.marketId,
          appID: this.appId,
          packageID: this.curPackageInfo.packageID,
          type,
          version: this.appVersion
        }
      });
    },
    // 获取下载token
    fetchDownloadToken() {
      this.btnLoading = true;
      getDownloadToken()
        .then((res) => {
          this.btnLoading = false;
          if (res && res.token) {
            this.download(`${this.downloadUrl}?token=${res.token}`);
          }
        })
        .catch((err) => {
          errorHandle(err);
          this.btnLoading = false;
        });
    },
    // 下载
    download(downloadPath) {
      let aEle = document.querySelector('#down-a-element');
      if (!aEle) {
        aEle = document.createElement('a');
        aEle.setAttribute('download', 'filename');
        document.body.appendChild(aEle);
      }
      aEle.href = downloadPath;
      if (document.all) {
        aEle.click();
      } else {
        const e = document.createEvent('MouseEvents');
        e.initEvent('click', true, true);
        aEle.dispatchEvent(e);
      }
    },
    // 下载file软件包
    handleDownloadFile() {
      const params = {
        marketID: this.marketId,
        appID: this.appId,
        version: this.appVersion
      };
      downloadFilePackage(params).then((res) => {
        if (res) {
          const blob = new Blob([res.data], {
            type: 'application/tgz' // 这里需要根据不同的文件格式写不同的参数
          });
          const eLink = document.createElement('a');
          eLink.download = `${this.appDetailInfo.name}.tgz`; // 这里需要自己给下载的文件命名
          eLink.style.display = 'none';
          eLink.href = URL.createObjectURL(blob);
          document.body.appendChild(eLink);
          eLink.click();
          URL.revokeObjectURL(eLink.href);
          document.body.removeChild(eLink);
        }
      });
    },
    onScrolls() {},
    // 点击锚点地址栏不追加记录
    changeHash(idName) {
      document.querySelector(idName).scrollIntoView(true);
    },
    // Helm 类型安装命令
    handleOpenInstallHelm() {
      this.showOpenInstallHelm = true;
    },
    // Docker 类型安装命令
    handleOpenInstallDocker() {
      this.showOpenInstallDocker = true;
    },
    // Ram 类型安装命令
    handleOpenInstallRam() {
      this.showOpenInstallRam = true;
    },
    // 时间转换
    timmer(date) {
      return fetchdayTimes(date);
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'src/styles/newappdetail.scss';

.el-icon-question {
  font-size: 16px;
}
</style>
<style lang="scss" scoped>
.helm {
  border: 1px solid #ed0cbc;
  ::v-deep .el-radio__inner {
    background: #ed0cbc;
  }
}
.docker {
  border: 1px solid red;
  ::v-deep .el-radio__inner {
    background: red;
  }
}
.ram {
  border: 1px solid #16b26c;
  ::v-deep .el-radio__inner {
    background: #16b26c;
  }
}
.file {
  border: 1px solid #0d4ee6;
  ::v-deep .el-radio__inner {
    background: #0d4ee6;
  }
}

.backtop {
  position: fixed;
  bottom: 100px;
  right: 14px;
  z-index: 999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
}
.wechart {
  width: 140px;
  height: 140px;
}
.app_detail_introduce {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI',
    -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
  font-weight: 400;
  border: 1px solid transparent;
  background-color: #fafafa;
  padding: 0 24px 24px;

  // padding-bottom: 24px;
  h1 {
    font-size: 30px;
    font-weight: 400;
    line-height: 47px;
    color: #1f2f3d;
    margin: 38px 0px 16px;
  }

  h2 {
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    color: #1f2f3d;
    margin: 28px 0px 14px;
  }

  h3 {
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    padding: #1f2f3d;
    margin: 24px 0px 12px;
  }

  p {
    // text-indent: 24px;
    font-size: 14px;
    letter-spacing: 1px;
    line-height: 21px;
    margin-bottom: 6px;
    color: #5e6d82;
  }

  ol,
  ul {
    margin: 10px 0;

    li {
      margin-left: 32px !important;
      margin-bottom: 8px;
      font-size: 14px;
      letter-spacing: 0.5px;
      line-height: 21px;
      color: #5e6d82;
    }

    li::marker {
      // font-weight: 600 !important;
      // color: #000 !important;
    }
  }

  img {
    width: 100%;
    height: 100%;
  }

  code {
    word-wrap: normal;
    font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;
    -webkit-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
    line-height: 1.5;
    margin: 0.5em 0;
    overflow: auto;
    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;
    text-align: left;
    text-shadow: 0 1px #fff;
    white-space: pre;
    word-break: normal;
    word-spacing: normal;
    background-color: #f5f2f0;
    border: 1px solid #f5f2f0;
    border-radius: 4px 4px;
    display: block;
    font-size: 14px;
    padding: 10px;
    text-indent: 0;
  }

  ul li {
    list-style: disc;
    margin-left: 26px;
  }

  ol li {
    list-style: decimal;
    margin-left: 26px;
  }

  table,
  table tr th,
  table tr td {
    border: 1px solid #ccc;
    padding: 12px;
    line-height: 1.5;
    min-width: 30px;
    padding: 3px 5px;
  }

  table tr th {
    text-align: center;
    background-color: #f5f2f0;
    font-weight: 700;
  }
}

.price {
  color: #1890ff;
  font-size: 20px;
}

.el-icon-user-solid,
.el-icon-phone {
  font-size: 20px;
}

.logo_img {
  line-height: 40px;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.user_logo span img {
  width: 100%;
}

.show_price {
  position: relative;
}

.installNum {
  position: absolute;
  right: 5%;
  top: 44%;

  .spanTitle {
    font-size: 14px;
    color: #6e7070;
  }

  .spanValue {
    font-weight: 500;
    font-size: 16px;
  }
}

.breadTitle:hover {
  cursor: pointer;
  color: #5a9cf8;
}

.jump_btn {
  width: 140px;
  height: 41px;
  text-align: center;
  font-family: PingFangSC-Regular, PingFang SC;
  margin-bottom: 0;
  font-weight: 400;
  background-color: #006fc2;
  border: 1px solid #006fc2;
  color: #fff;
  border-radius: 2px;
  padding: 9px 15px;
  cursor: pointer;
  margin-right: 24px;
}

.infotabs {
  margin-top: 40px;

  .el-tabs__nav-wrap::after {
    position: static !important;
  }

  .el-tabs__item {
    font-size: 18px;
    color: #006fc2;
  }

  .el-tabs__content {
    padding: 0px;
  }

  .el-tabs__active-bar {
    background-color: #000;
  }

  .el-tabs__item.is-active {
    color: #000;
  }
}

.btns_box {
  .cssbuttons-io {
    position: relative;
    font-family: inherit;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 0.05em;
    border-radius: 0.3em;
    border: none;
    background: linear-gradient(to right, #1890ff);
    color: #1890ff;
    overflow: hidden;
    border: 1px solid #1890ff;
  }

  .cssbuttons-io svg {
    width: 1.2em;
    height: 1.2em;
    margin-right: 0.5em;
  }

  .cssbuttons-io span {
    position: relative;
    z-index: 10;
    transition: color 0.4s;
    display: inline-flex;
    align-items: center;
    // padding: 0.5em 1em 0.5em 1em;
    // padding: 0.4rem 2rem;
    padding: 5px 30px;
  }

  .cssbuttons-io span:hover {
    color: #fff;
  }

  .cssbuttons-io::before,
  .cssbuttons-io::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .cssbuttons-io::before {
    content: '';
    background: #fff;
    width: 120%;
    left: -10%;
    transform: skew(30deg);
    transition: transform 0.4s cubic-bezier(0.3, 1, 0.8, 1);
  }

  .cssbuttons-io:hover::before {
    transform: translate3d(100%, 0, 0);
  }

  .cssbuttons-io:active {
    transform: scale(0.95);
  }
}

.timeUpdate {
  position: absolute;
  right: 5%;
  bottom: 2%;
  font-size: 12px;
  color: rgba(84, 88, 90, 0.7);
}

.text-body {
  color: rgb(134, 134, 134);
}

/*Text*/
.text-title {
  font-size: 1.5em;
  font-weight: bold;
}

/*Hover*/
.card:hover {
  border-color: #008bf8;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.25);
}

.card:hover .card-button {
  transform: translate(-50%, 50%);
  opacity: 1;
}

.leftSidebar {
  padding-left: 9px;
  margin-top: 20px;
  height: 38px;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  li {
    height: 100%;
    margin: 0px 30px 0px 10px;
    color: #006fc2;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;

    p {
      margin: 0;
      padding-top: 10px;
    }
  }

  .active {
    color: #006fc2;
    border-bottom: 2px solid #006fc2;
  }
}

.by {
  color: #006fc2;
  cursor: pointer;
}

ul {
  // width: 100%;
  margin-bottom: 0em;
}

.appVersionSpan {
  display: inline-block;
  // padding: 0px 18px;
}


.block_box_version {
  min-width: 80px;
  height: 24px;
  margin-right: 14px;
  padding: 2px;
  line-height: 24px;
  cursor: pointer;
  margin-bottom: 10px;
  margin-top: 4px;
  font-size: 14px;
  color: #3c3c3c;
  border: 1px solid #E9EAEC;
  border-radius: 4px;
  background-color: #fff;
}

.appVersionPackage{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 20px;
}
.appVersionBox {
  display: flex;
  align-items: center;
  width: 100%;
  height: 20px;
  .appTypeIcon{
    width: 20px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 18px;
      height: 18px;
    }
  }
  .appTypeVersion{
    min-width: 60px;
    text-align: center;
    height: 20px;
    line-height: 20px;
    color: #585858;
    padding: 0px 4px;
  }

}
.hostTitle {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #000;
}

.history_versions {
  width: 100%;
  min-height: 80px;
  margin-bottom: 50px;

  .versions_box {
    width: 100%;
    padding: 0px 3%;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .versions_name {
      font-size: 24px;
      font-weight: 600;
    }

    .versions_time {
      font-size: 14px;
    }
  }

  .versions_content {
    width: 100%;
    padding: 12px 3%;
    font-weight: 500;
    white-space: pre-line;
    font-size: 14px;
    letter-spacing: 1px;
    line-height: 21px;
    margin-bottom: 6px;
    color: #5e6d82;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/appstore/appDetail.vue